import { buildScopedI18n } from '../../utils/buildScopedI18n';
import calendarEsCL from './locales/es-CL.json';
import calendarEnUS from './locales/en-US.json';
import calendarPtBR from './locales/pt-BR.json';

export const calendarComponentI18n = buildScopedI18n({
  esCL: calendarEsCL,
  enUS: calendarEnUS,
  ptBR: calendarPtBR,
});
